<template>
  <mdb-navbar class="flexible-navbar white" position="top" double scrolling>
    <mdb-navbar-brand @click.native="toggleSideNav" class="button-collapse"><mdb-icon icon="bars"/></mdb-navbar-brand>
    <mdb-navbar-nav left>
      <mdb-breadcrumb>
        <mdb-breadcrumb-item v-for="(item,index) in computedPage" :key="index">
          {{ item }}
        </mdb-breadcrumb-item>
      </mdb-breadcrumb>
    </mdb-navbar-nav>
    <mdb-navbar-toggler/>
    <mdb-navbar-nav class="right-nav" right>
      <mdb-dropdown v-if="isLoggedIn" class="nav-item" tag="li" end>
        <mdb-dropdown-toggle slot="toggle" tag="li" outline="none" class="btn-transparent">
          <mdb-icon icon="user"/> <span class="clearfix d-none d-sm-inline-block">{{ userName }}</span>
        </mdb-dropdown-toggle>
        <mdb-dropdown-menu >
          <mdb-dropdown-item @click="logout">Выйти</mdb-dropdown-item>
        </mdb-dropdown-menu>
      </mdb-dropdown>
    </mdb-navbar-nav>
  </mdb-navbar>
</template>

<script>
import { mdbNavbar, mdbNavbarBrand, mdbNavbarNav, mdbNavbarToggler, mdbBreadcrumb, mdbBreadcrumbItem, mdbDropdown, mdbDropdownToggle, mdbDropdownMenu, mdbDropdownItem, mdbIcon } from 'mdbvue'

import { mapActions } from 'vuex';
import store from '../store';

export default {
  name: 'Navbar',
  props: {
    page: {
      type: String
    }
  },
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbBreadcrumb,
    mdbBreadcrumbItem,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbIcon,
  },
  data () {
    return {
      activePage: this.page,
      toggle: false
    }
  },
  methods: {
    ...mapActions(['toggleSideNav']),
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
    }
  },
  computed: {
    isLoggedIn : function(){ return this.$store.getters.isLoggedIn},
    computedPage () {
      // return {
        // activePage: this.page
      // }
      return store.getters.breadcrumbs
    },
    userName: function(){ return localStorage.getItem('username') },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.navbar .nav-item {
  line-height: 24px;
  font-size: 16px;
}
.navbar .dropdown-toggle {
  padding: 0 10px;
  font-size: 16px;
}

.navbar ul {
  padding: 5px 0;
}

.navbar .btn {
  font-weight: 300;
}

.navbar-collapse {
  order: 0 !important;
}

.navbar .notifications-nav .dropdown-menu {
  width: 23rem; }

.navbar-expand-lg .navbar-nav {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
}

.btn-transparent {
  background-color: transparent !important;
  color: #000;
  text-transform: none;
  box-shadow: none !important;
}

.btn-transparent:hover, .btn-transparent:active {
  box-shadow: none !important;
}

</style>
